import React from "react";
import { arrayOf, bool, number, shape, string } from "prop-types";

import { largeScreen } from "src/shared/constants/screenSizes";
import { useIsMobile } from "src/shared/utilities/customHooks";

import HeaderNavButton from "../../../HeaderNavButton";
import { List, ListItem } from "../../../HeaderNavDropdownList";
import { useMainNavDropdown } from "../../../MainNav/hooks";
import AdvertiseLink from "../AdvertiseLink";
import * as S from "./styled";

const AdvertiseDropdown = props => {
  const {
    advertise_dropdown_links,
    advertise_total_count,
    advertise_url,
    show_advertise_banner
  } = props;

  const {
    dropdownRef,
    isActive,
    onClick,
    onMouseEnter,
    onMouseLeave
  } = useMainNavDropdown();
  const isMobile = useIsMobile(largeScreen);

  const AdvertiseBanner = show_advertise_banner ? (
    <S.AdvertiseBanner href={advertise_url}>
      <S.AdvertiseContent>
        <S.AdvertiseTitle>
          Grow Business with <br />
          Ad Products
        </S.AdvertiseTitle>
        <S.AdvertiseBody>Get Started</S.AdvertiseBody>
      </S.AdvertiseContent>
      <S.AdvertiseProductsIcon />
    </S.AdvertiseBanner>
  ) : null;

  const AvailableProducts = (
    <S.PopUpListItem>
      <S.PopUpContent>Your Available Products</S.PopUpContent>
    </S.PopUpListItem>
  );

  const dropdownLinks = advertise_dropdown_links.map(
    ({ count, is_new, title, url }) => (
      <ListItem
        key={title}
        className="jsAdvertisingCenterLink"
        data-gtm-header-menu="PRO Dashboard"
        data-gtm-label={title.replace(/ /g, "_")}
        link={url}
        title={title}
      >
        {is_new && <S.Callout>New</S.Callout>}
        {count > 0 && <S.Pill>{count}</S.Pill>}
      </ListItem>
    )
  );

  return isMobile ? (
    <AdvertiseLink {...props} />
  ) : (
    <>
      <HeaderNavButton
        aria-expanded={isActive}
        aria-haspopup="true"
        aria-label="Advertise Dropdown"
        isNew={advertise_total_count > 0}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        Advertise &nbsp;
        <S.CaretIcon />
      </HeaderNavButton>
      <div ref={dropdownRef}>
        <S.StyledMenuPopup
          isActive={isActive}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          role="tooltip"
        >
          <List>
            {AdvertiseBanner}
            {AvailableProducts}
            {dropdownLinks}
          </List>
        </S.StyledMenuPopup>
      </div>
    </>
  );
};

AdvertiseDropdown.propTypes = {
  advertise_total_count: number,
  advertise_url: string.isRequired,
  advertise_dropdown_links: arrayOf(
    shape({ count: number, is_new: bool, url: string, title: string })
  ).isRequired,
  show_advertise_banner: bool
};

AdvertiseDropdown.defaultProps = {
  advertise_total_count: 0,
  show_advertise_banner: false
};

export default AdvertiseDropdown;
